exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ndiv.modal-footer input.btn.btn-primary{\n    background: green;\n    color:white;\n}\ndiv.modal-footer button.btn.btn-danger {\n    background: red;\n    color:white;\n}\n.btn{\n    padding: 2px 4px;\n    padding: 0.1rem 0.4rem;\n}\n.bg-blue {\n    background-color:\n        #0d4295 !important;\n}\n\n", ""]);

// exports
